import EventEmitter from '../../common/EventEmitter';
import { ProxyType } from '../../config/ProxyConfig';
import { InternalEvents } from '../../events';
import { SourceType } from '../../webrtc/agent/interfaces';
import { ObjectRequest } from '../interfaces';
import Timer from '../Timer';

// Fetch API only rejects when a network error occurs.
export const getErrorCodeFromError = (error: unknown): number => {
  switch ((error as Record<string, string>)?.name) {
    case 'AbortError':
      return 844; // Timeout
    case 'FetchError':
      return 845; // Other fetch error
    case 'TypeError':
      return 846; // Failed to fetch
    default:
      return 843; // Unknown error
  }
};

export interface DispatchErrorIngest {
  type: InternalEvents.REQUEST_INGEST | InternalEvents.PROXY_INGEST;
  err: unknown;
  eventEmitter: EventEmitter;
  request: ObjectRequest;
  modifyRequest?: ObjectRequest;
  sourceType: SourceType;
  proxyType?: ProxyType;
}

const dispatchErrorIngest = async (
  args: DispatchErrorIngest
): Promise<void> => {
  const { request, sourceType, err, type, modifyRequest } = args;
  const timer = new Timer(request.timer);
  if (!timer.getEnd()) {
    timer.stop();
  }
  const basic = {
    request,
    modifyRequest,
    timer,
    objectId: modifyRequest?.objectId ?? request.objectId,
    sourceType,
    status: getErrorCodeFromError(err)
  };
  if (type === InternalEvents.PROXY_INGEST) {
    const data = {
      ...basic,
      proxyType: args.proxyType as ProxyType
    };
    return args.eventEmitter.dispatch({
      type,
      data,
      error: err as Error,
      sourceType,
      proxyType: args.proxyType as ProxyType
    });
  }
  return args.eventEmitter.dispatch({
    type,
    data: basic,
    error: err as Error
  });
};

export default dispatchErrorIngest;
